import {
  REQUEST_APPEAL_SUCCESS,
  CLOSE_SUCCESS,
  REQUEST_ERROR_HIDE,
  REQUEST_APPEAL_ERROR,
  REQUEST_APPEAL_ALREADY_REPORTED
} from '../constants';

const stepInitialState = {
  action: 'submit',
  data: {
    service_number: ''
  }
};

const requestDataSuccess = (state = stepInitialState, action) => {
  switch (action.type) {
    case REQUEST_APPEAL_SUCCESS:
      return {
        ...state,
        ...action.payload,
        action: action.payload.action
      };
    case CLOSE_SUCCESS:
    case REQUEST_APPEAL_ERROR:
    case REQUEST_APPEAL_ALREADY_REPORTED:
    case REQUEST_ERROR_HIDE:
      return {
        ...state,
        action: stepInitialState.action
      };
    default:
      return state;
  }
};

export default requestDataSuccess;
